module.exports = __webpack_public_path__ + "static/img/齿轮齿条自动润滑系统装置.7359cdc8.jpg";